import './init-sentry';
import './init-i18next';

import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { injectStyle } from 'react-toastify/dist/inject-style';

import { HubErrorBoundary } from '@adflow/frontend/ui-common';
import { HighlightMetaProvider } from '@adflow/frontend/util-common';

import { queryClient } from './queryClient';
import { router } from './routes';

injectStyle();

const root = ReactDOM.createRoot(document.querySelector('#root')!);
root.render(
	<StrictMode>
		<HubErrorBoundary>
			<HighlightMetaProvider>
				<QueryClientProvider client={queryClient}>
					<RouterProvider router={router} />
				</QueryClientProvider>
			</HighlightMetaProvider>
		</HubErrorBoundary>
	</StrictMode>
);
